import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

type TokenExpiryModalProps = {
  open: boolean;
  onClose: () => void;
  autoCloseDuration?: number;
};

const DEFAULT_AUTO_CLOSE_MS = 3000;

const TokenExpiryModal: React.FC<TokenExpiryModalProps> = ({
  open,
  onClose,
  autoCloseDuration = DEFAULT_AUTO_CLOSE_MS,
}) => {
  useEffect(() => {
    if (!open) {
      return;
    }

    const timer = window.setTimeout(() => {
      onClose();
    }, autoCloseDuration);

    return () => window.clearTimeout(timer);
  }, [autoCloseDuration, onClose, open]);

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="token-expired-title">
      <DialogTitle id="token-expired-title">Oturum Süresi Doldu</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Token süreniz doldu. Login ekranına yönlendiriliyorsunuz.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Tamam
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenExpiryModal;
